import Axios from "../../../utils/axios";

export const getEvents = (data) => {
    return (dispatch) => {
        Axios.get("/event-list-with-details", dispatch, "GET_EVENTS", data);
    };
};